

const FiscalCodeInputFiled = (props: any) => {
  let valueInput = props.value ?? "";
  let type = props.type ?? "text";
  let placeholder = props.placeholder ?? "";
  let focusOut = props.focusOut ? props.focusOut : () => {};
  let name = props.name ?? "";
  let min = props.min ?? "";
  let max = props.max ? props.max : "";
  let disabled = props.disabled ?? false;
  let readOnly = props.readOnly ?? false;

  const UpdadeValue = (e: any) => {
    const cursorPos = e.target.selectionStart;
    const value = e.target.value.toUpperCase();
    props.handleChange(value);

    // call validation if input length is 16
    if (value.length === 16) focusOut(value);

    // restore the cursor position
    setTimeout(() => {
      e.target.setSelectionRange(cursorPos, cursorPos);
    }, 0);
  };

  return (
    <input
      type={type}
      disabled={disabled}
      readOnly={readOnly}
      min={min}
      max={max}
      name={name}
      id={name}
      value={valueInput}
      placeholder={placeholder}
      onChange={(e) => UpdadeValue(e)}
      onBlur={(e) => focusOut(e.target.value)}
      onFocus={(e) => UpdadeValue(e)}
      className={`form-control Input ${props.className}`}
    />
  );
};

export default FiscalCodeInputFiled;
